/**
 * body を key に載せるためのダイジェスト。SSR とクライアントで同じ値になれば足りるため
 * 暗号強度は要らない。body をそのまま直列化すると、秘匿のために URL から body へ移した値が
 * SSR ペイロードのキーとしてページに出てしまう。
 */
const digest = (value: object): string => {
  const json = JSON.stringify(value);
  let hash = 2166136261;
  for (let i = 0; i < json.length; i++) {
    hash ^= json.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return (hash >>> 0).toString(36);
};

/**
 * useFetch / useAsyncFetch の key を path / query / customKey / リクエスト内容から決定的に組み立てる。
 *
 * Nuxt 4 では同じ key の useFetch が data/error/status の refs を共有するため、
 * リクエストを区別する入力をすべて key に含める（ADR-094）。同じ path でも
 * query・method・body が違えば別リクエストであり、独立したキャッシュを持たせる。
 *
 * customKey は上記がすべて同じでも別キャッシュを持ちたい場合の追加識別子。
 */
export const buildFetchKey = (path: string, query?: object | undefined, customKey?: string, request?: { method?: string; body?: object }): string => {
  const segments = [path];
  if (query) segments.push(`query=${JSON.stringify(query)}`);
  if (request?.method) segments.push(`method=${request.method}`);
  if (request?.body) segments.push(`body=${digest(request.body)}`);
  const base = segments.join(',');
  return customKey ? `${base}:${customKey}` : base;
};
